/**
 * What went wrong with the dictation Engine menu (`use-dictation-engine-menu.ts`),
 * as Settings › Voice and onboarding both show it: a choice that did not
 * happen, or a chosen model whose download failed, with a retry.
 */
import { Button } from "@/components/ui";
import type { DictationEngineMenu } from "@/desktop/use-dictation-engine-menu";
import { useT } from "@/i18n";
import { commonMessages } from "@/i18n/messages/common";
import { settingsVoiceMessages } from "@/i18n/messages/settings-voice";
import { SettingsFieldError } from "./settings-text-field";

export function DictationEngineMenuError({
  menu,
  testId,
}: {
  menu: Pick<DictationEngineMenu, "failed" | "error" | "retry">;
  /** Prefix of the error line's and the retry's test ids. */
  testId: string;
}) {
  const t = useT(settingsVoiceMessages);
  const tCommon = useT(commonMessages);
  const error = menu.failed
    ? t("modelDownloadFailedLine", { name: menu.failed })
    : menu.error;
  return (
    <>
      <SettingsFieldError error={error} testId={`${testId}-error`} />
      {menu.failed ? (
        <Button
          size="sm"
          variant="ghost"
          onClick={menu.retry}
          data-testid={`${testId}-retry`}
        >
          {tCommon("retry")}
        </Button>
      ) : null}
    </>
  );
}
